const PAYMENT_RETURN_KEY = "paymentReturnTo";

const savePaymentReturn = (location) => {
  try {
    sessionStorage.setItem(
      PAYMENT_RETURN_KEY,
      JSON.stringify({
        path: `${location.pathname}${location.search || ""}`,
        state: location.state ?? null,
      }),
    );
  } catch (err) {
    console.error("Failed to save payment return path:", err);
  }
};

const goToPaymentReturn = () => {
  let saved = null;
  try {
    saved = JSON.parse(sessionStorage.getItem(PAYMENT_RETURN_KEY));
    sessionStorage.removeItem(PAYMENT_RETURN_KEY);
  } catch (err) {
    saved = null;
  }

  if (!saved?.path) {
    window.location.href = "/";
    return;
  }

  window.history.replaceState(
    { usr: saved.state, key: "default", idx: 0 },
    "",
    saved.path,
  );
  window.location.reload();
};

export { savePaymentReturn, goToPaymentReturn };
